import giftImg from "./giftImg.png";
import transferImg from "./transferImg.png";
import cemacoImg from "./cemacoImg.png";
import "./styles.css";

export default function Gift() {
    return (
        <section className="gift-section">
            <img src={giftImg} alt="Regalos" className="gift-main-icon" />

            <h2 className="gift-title">SUGERENCIA DE REGALOS</h2>

            <p className="gift-description">
                El mejor regalo es tu presencia, pero si deseas tener un detalle con
                nosotros, te compartimos estas opciones:
            </p>

            <div className="gift-option">
                <img
                    src={transferImg}
                    alt="Transferencia bancaria"
                    className="gift-option-icon"
                />
                <h3 className="gift-option-title">TRANSFERENCIA BANCARIA</h3>
                <p className="gift-option-text">
                    Si deseas obsequiarnos algo, puedes hacerlo de manera sencilla a la
                    siguiente cuenta:
                </p>
                <p className="gift-account">
                    Banrural
                    <br />
                    Cuenta de ahorro
                    <br />
                    4733145611
                </p>
            </div>

            <div className="gift-option">
                <img
                    src={cemacoImg}
                    alt="Regalo en línea con Cemaco"
                    className="gift-option-icon"
                />
                <h3 className="gift-option-title">REGALO EN LÍNEA</h3>
                <p className="gift-option-text">
                    También puedes hacernos un regalo en línea a través de nuestra lista
                    de bodas en Cemaco:
                </p>

                <a
                    href="https://www.cemaco.com/list/BODAG%C3%81LVEZBARRIOS21112026"
                    target="_blank"
                    rel="noreferrer"
                    className="gift-link"
                >
                    Ver listado de Cemaco
                </a>
            </div>
        </section>
    );
}
